import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

console.log('[Firebase Init] Starting Firebase initialization at:', new Date().toISOString());

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_CONFIG_MEASUREMENT_ID
};

console.log('[Firebase Init] Config loaded, calling initializeApp at:', new Date().toISOString());

// init firebase
const app = initializeApp(firebaseConfig);

console.log('[Firebase Init] initializeApp complete at:', new Date().toISOString());
//const analytics = getAnalytics(app);

// init firestore service
console.log('[Firebase Init] Starting Firestore initialization at:', new Date().toISOString());
const db = getFirestore()
console.log('[Firebase Init] Firestore ready at:', new Date().toISOString());

export default db
